import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { verifyNINAction } from '../../../../redux/slices/verifyNINSlice';
import { useAppDisPatch, useAppSelector } from '../../../../redux/store';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';
import ConfirmNINVerification from './ConfirmNINVerification';
import VerifyNINInformation from './VerifyNINInformation';

interface VerifyNINModalProps {
  data?: any;
}

const VerifyNINModal: React.FC<VerifyNINModalProps> = ({ data }) => {
  const modalContext = useContext(ModalContext);
  const verifyNINData = useAppSelector((state) => state.verifyNIN);
  const dispatch = useAppDisPatch();

  const sliderIndex = verifyNINData.sliderIndex;

  return (
    <Container>
      <ModalContainer
        label='Re-confirm NIN'
        showSuccessComponent={modalContext?.showSuccessComponent}
        width={sliderIndex === 0 ? '520px' : '782px'}
        handleCloseIconClick={() => {
          dispatch(verifyNINAction.resetSliderIndex());
        }}
      >
        <FormContainer>
          <SlidesTrack sliderIndex={sliderIndex}>
            <VerifyNINInformation data={data} />
            <ConfirmNINVerification data={data} />
          </SlidesTrack>
        </FormContainer>
      </ModalContainer>
    </Container>
  );
};

export default VerifyNINModal;

const FormContainer = styled.div`
  width: 100%;
  overflow: hidden;
`;

const SlidesTrack = styled.div<{ sliderIndex: number }>`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 100%;
  width: 100%;
  transform: translateX(${({ sliderIndex }) => `-${100 * sliderIndex}%`});
  transition: transform 0.3s ease-in-out;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 63px;
`;
